import React from 'react';

import cn from 'classnames';
import { noop, omit } from 'lodash';
import {
  string,
  arrayOf,
  shape,
  func,
  bool,
  oneOfType,
  element,
} from 'prop-types';

import Toolbar from '@mui/material/Toolbar';

import ModalPropTypes, { ModalDefaultProps } from 'propTypes/ModalPropTypes';

import s from './Wrapper.css';

const EXTRACTED_PROPS_MUI_APPBAR = [
  'moduleAccess',
  'profilePic',
  'router',
  'firstName',
  'lastName',
  'email',
  'showGoogleTranslate',
  'toggleGoogleTranslate',
  'shouldRenderAffiliationLink',
  'staticContext',
  'hideMenu',
  'isHovered',
  'hideModal',
  'isModalVisible',
  'isOnboarding',
  'mediaInfo',
  'preferredName',
  'refreshModalProps',
  'showModal',
  'user',
];

export default class Wrapper extends React.Component {
  render() {
    const { color, items, className, style, hasSubNav, ...internal } =
      this.props;

    const {
      isPublicMemberPage,
      cancelHidingMenu,
      pageDetails,
      hasBottomBorder,
      ...restProps
    } = internal;

    return (
      <nav
        data-appbar="1"
        className={cn(s.container, className, {
          [s.hasSubNav]: hasSubNav,
          [s.hasBottomBorder]: hasBottomBorder,
          [s.noPageDetails]: !pageDetails,
        })}
        style={style}
        {...omit(restProps, EXTRACTED_PROPS_MUI_APPBAR)}
      >
        {pageDetails}
        <Toolbar
          className={cn(s.toolbar, {
            [s.publicMemberToolbar]: isPublicMemberPage,
          })}
        >
          {items}
        </Toolbar>
      </nav>
    );
  }
}

Wrapper.propTypes = {
  ...ModalPropTypes,
  className: string,
  color: string,
  firstName: string,
  isModalVisible: bool,
  isOnboarding: bool,
  isPublicMemberPage: bool,
  lastName: string,
  items: arrayOf(oneOfType([element, string])),
  mediaInfo: shape({}).isRequired,
  moduleAccess: shape({}),
  preferredName: string,
  profilePic: string,
  shouldRenderAffiliationLink: bool,
  showGoogleTranslate: bool,
  style: shape({}),
  toggleGoogleTranslate: func,
  user: shape({}),
  hasBottomBorder: bool,
};

Wrapper.defaultProps = {
  ...ModalDefaultProps,
  color: 'green',
  items: [],
  style: {},
  className: undefined,
  firstName: null,
  isModalVisible: false,
  isOnboarding: false,
  isPublicMemberPage: false,
  lastName: null,
  moduleAccess: null,
  preferredName: null,
  profilePic: null,
  shouldRenderAffiliationLink: false,
  showGoogleTranslate: false,
  toggleGoogleTranslate: noop,
  user: null,
  hasBottomBorder: false,
};
